import { IError } from '../base/error'
import ServiceBase from '../base/service.base'
import { ICompanyCreateRequest } from '../company/company.types'

import { IZipcodeResponseDTO } from './providers.types'

export class Providers extends ServiceBase {
  private mainURL = '/providers'

  public async cnpjConsult(cnpj: string): Promise<ICompanyCreateRequest> {
    const url = `${this.mainURL}/receitaws/${cnpj}`

    const response = await this.request.get<ICompanyCreateRequest, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getZipcode(zipCode: string): Promise<IZipcodeResponseDTO> {
    const url = `${this.mainURL}/zipCode/${zipCode}`

    const response = await this.request.get<IZipcodeResponseDTO, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
